import React, { useState, forwardRef, useContext } from 'react'
import { Modal, Button, Toast } from '@ow/comps'
import OrgContext from '../../hooks/org/context'
import Tree from '../../tree/tree'

const ChangeGroup = function ({ userIds, closeModal, changeOrg }, ref) {
  const { orgs } = useContext(OrgContext) || {}
  const [orgId, setOrgId] = useState(null)
  const [checkedKeys, setCheckedKeys] = useState([])

  const updateCheckedCompany = (keys, node) => {
    setOrgId(node.key)
    setCheckedKeys([node.key])
  }
  console.log('user->>>',orgs)

  const onClickChangeOrg = () => {
    if (orgId && changeOrg) {
      changeOrg(userIds, orgId, () => {
        Toast.success({
          title: '通知',
          description: '操作成功！',
        })

        closeModal()
      }).catch((error) => {
        if (error.response.data.msg) {
          Toast.error({
            title: '操作失败',
            description: error.response.data.msg,
          })
        }
      })
    }
  }
  return (
    <Modal
      ref={ref}
      title="转移部门"
      size="md"
      showCloseButton
      // eslint-disable-next-line react/no-unstable-nested-components
      footer={() => {
        return (
          <div className="w-full flex flex-row justify-end gap-2">
            <Button stroke onClick={closeModal}>
              取消
            </Button>
            <Button type="primary" disabled={orgId === null} onClick={onClickChangeOrg}>
              确定
            </Button>
          </div>
        )
      }}
    >
      <div className="w-full">
        <Tree
          datas={orgs || []}
          checkable
          updateCheckedKeys={updateCheckedCompany}
          checkedKeys={checkedKeys}
        />
      </div>
    </Modal>
  )
}

export default forwardRef(ChangeGroup)
